import { useState } from 'react';
import { EmailTemplate, EmailVariables, Candidate } from '../types';

export interface EmailExportState {
  isExportDialogOpen: boolean;
  selectedTemplate: EmailTemplate | null;
  selectedCandidate: Candidate | null;
  customVariables: Partial<EmailVariables>;
}

export const useEmailExport = () => {
  const [exportState, setExportState] = useState<EmailExportState>({
    isExportDialogOpen: false,
    selectedTemplate: null,
    selectedCandidate: null,
    customVariables: {}
  });

  const openExportDialog = (
    template: EmailTemplate,
    candidate: Candidate,
    customVariables: Partial<EmailVariables> = {}
  ) => {
    setExportState({
      isExportDialogOpen: true,
      selectedTemplate: template,
      selectedCandidate: candidate,
      customVariables
    });
  };

  const closeExportDialog = () => {
    setExportState({
      isExportDialogOpen: false,
      selectedTemplate: null,
      selectedCandidate: null,
      customVariables: {}
    });
  };

  const updateCustomVariables = (variables: Partial<EmailVariables>) => {
    setExportState(prev => ({
      ...prev,
      customVariables: { ...prev.customVariables, ...variables }
    }));
  };

  return {
    exportState,
    openExportDialog,
    closeExportDialog,
    updateCustomVariables
  };
};